import * as z from 'zod';

import { zodJSPlainDate } from '../dates/BrandedDate';
import { EnsureAllKeys } from '../utils';

export const PortalPaymentStopSetting = z.enum(['none', 'exact', 'any']);
export type PortalPaymentStopSetting = z.infer<typeof PortalPaymentStopSetting>;

export const StopSettings = z.object({
  portalPayments: PortalPaymentStopSetting,
  emailsPaused: z.boolean(),
  documentAccessPaused: z.boolean(),
  drawsPaused: z.boolean(),
  advancesPaused: z.boolean().optional(), // TODO: Make required
  advancesPausedUntilDate: zodJSPlainDate.optional(),
  omitFromPayoffAutomation: z.boolean(),
  omitFromDelinquentInterestAutomation: z.boolean().optional(),
  omitFromLateFeeAutomation: z.boolean().optional(),
  miCancellationReviewRequired: z.boolean().optional(), // TODO: Make required
  miCancellationReviewReason: z.string().optional(),
});
export type StopSettings = z.infer<typeof StopSettings>;

export const DEFAULT_STOP_SETTINGS: EnsureAllKeys<StopSettings> = {
  portalPayments: 'any',
  emailsPaused: false,
  documentAccessPaused: false,
  drawsPaused: false,
  advancesPaused: false,
  advancesPausedUntilDate: undefined,
  omitFromPayoffAutomation: false,
  omitFromDelinquentInterestAutomation: false,
  omitFromLateFeeAutomation: false,
  miCancellationReviewRequired: false,
  miCancellationReviewReason: undefined,
} as const;

export const getDefaultStopSettings = (
  forStatus: 'active' | 'bankruptcy' | 'reo' | 'liquidation' = 'active',
): EnsureAllKeys<StopSettings> => {
  switch (forStatus) {
    case 'bankruptcy':
    case 'liquidation':
      return {
        portalPayments: 'none',
        emailsPaused: true,
        documentAccessPaused: true,
        drawsPaused: true,
        advancesPaused: false,
        advancesPausedUntilDate: undefined,
        omitFromPayoffAutomation: true,
        omitFromDelinquentInterestAutomation: true,
        omitFromLateFeeAutomation: true,
        miCancellationReviewRequired: false,
      };
    case 'reo':
      return {
        portalPayments: 'none',
        emailsPaused: true,
        documentAccessPaused: false,
        drawsPaused: true,
        advancesPaused: false,
        advancesPausedUntilDate: undefined,
        omitFromPayoffAutomation: true,
        omitFromDelinquentInterestAutomation: true,
        omitFromLateFeeAutomation: true,
        miCancellationReviewRequired: false,
      };
    case 'active':
    default:
      return { ...DEFAULT_STOP_SETTINGS };
  }
};
